export default {
  'Peer Reviewed': 'green.100',
  'Not Peer Reviewed': 'red.100',
}
